// @ts-strict-ignore
import { ArticleTechnicalInfoVO } from '@article/model/vo/article.vo';
import { ArticleDataService } from '../service/article-data.service';
import { ArrayUtils } from '@shared/util/array-utils';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ArticleTechnicalInfoService } from '../service/article-technical-info.service';

@Injectable({ providedIn: 'root' })
export class ArticleTechnicalInfoManager {
  constructor(
    private articleDataService: ArticleDataService,
    private articleTechnicalInfoService: ArticleTechnicalInfoService,
    ) {}

  private _articleIdToTechnicalInfoMap: Map<number, ArticleTechnicalInfoVO> = new Map<number, ArticleTechnicalInfoVO>();

  public isTechnicalInfoLoaded(articleId: number): boolean {
    return this._articleIdToTechnicalInfoMap.has(articleId);
  }

  public getTechnicalInfo(articleId: number): ArticleTechnicalInfoVO | null {
    if (!this.isTechnicalInfoLoaded(articleId)) {
      return null;
    }
    return this._articleIdToTechnicalInfoMap.get(articleId);
  }

  public loadTechnicalInfoByArticleIds(articleIds: number[]): void {
    this.loadTechnicalInfoByArticleIdsObservable(articleIds).subscribe({
      next: ((arrayResponse: ArticleTechnicalInfoVO[]) => {
        this.articleTechnicalInfoService.notifyArticleTechnicalInfoLoadedSuccess(arrayResponse);
      }),
      error: ((error: any) => this.articleTechnicalInfoService.notifyArticleTechnicalInfoLoadedFailure(error))
    });
  }

  public loadTechnicalInfoByArticleIdsObservable(articleIds: number[], isOverlayRequired: boolean = false): Observable<ArticleTechnicalInfoVO[]> {
    if (ArrayUtils.isEmpty(articleIds)) return of([]);

    const alreadyYetLoadedIds = articleIds.filter((articleId) => this.isTechnicalInfoLoaded(articleId));
    const notYetLoadedIds = articleIds.filter((articleId) => !this.isTechnicalInfoLoaded(articleId));
    const alreadyLoadedInfos = alreadyYetLoadedIds.map((articleId) => this.getTechnicalInfo(articleId));

    if(notYetLoadedIds.length == 0) return of(alreadyLoadedInfos);

    return this.articleDataService.loadTechnicalInfoByArticleIds(notYetLoadedIds, isOverlayRequired).pipe(
      map((technicalInfoMap) => {
        const infos: ArticleTechnicalInfoVO[] = [];
        if (technicalInfoMap) {
          this._articleIdToTechnicalInfoMap = new Map([...this._articleIdToTechnicalInfoMap, ...technicalInfoMap]);
        }
        return [...infos, ...alreadyLoadedInfos];
      })
    );
  }
}
